@if (depositWarning(); as warning) {
  <pr-warning>{{ warning }}</pr-warning>
}
